import React from "react";
import { useAppSelector } from "../app/hooks";
import AppDrawer from "../components/drawer/Drawer";
import CreateNationality from "./nationality/CreateNationality";
import CreateCity from "./city/CreateCity";
import CreateState from "./state/CreateState";
import CreateCountry from "./country/CreateCountry";
import CreateFlightPlace from "./FlightPlace/CreateFlightPlace";
import CreateMenu from "./menu/CreateMenu";
import CreateRights from "./rights/CreateRights";
import CratePromoCode from "./promocode/CreatePromoCode";
import CreateGiftCode from "./giftcode/CreateGiftCode";
import CreateMemberShipPlan from "./membershipplan/CreateMemberShipPlan";
import CreateWalletAmountReturn from "./walletamountreturn/CreateWalletAmountReturn";
import CreateSpecialityType from "./specialitytype/CreateSpecialityType";
import CreateRoomType from "./roomtype/CreateRoomType";
import CreateVehicleSharingPax from "./vehiclesharingpax/CreateVehicleSharingPax";
import CreateItineraryFacility from "./ItineraryFacility/CreateItineraryFacility";
import CreateRegion from "./region/CreateRegion";
import CreateGst from "./gst/CreateGst";
import CreateCurrency from "./currency/CreateCurrency";
import CreateBank from "./bank/CreateBank";
import CreateBankAccount from "./bankaccount/CreateBankAccount";
import CreateTopupRequest from "./topuprequest/CreateTopupRequest";
import CreateSetting from "./setting/CreateSetting";
// import CreateTourService from "./tourservice/CreateTourService";

const Drawers = () => {
  const isDrawerOpen = useAppSelector((state) => state.drawer.open);
  const drawerName = useAppSelector((state) => state.drawer.name);

  //   ***********Note : Here you need to add key as a drawerName same which you passed from create Button***********

  const drawerComponents: Record<string, React.JSX.Element> = {
    menuForm: <CreateMenu />,
    nationalityForm: <CreateNationality />,
    cityForm: <CreateCity />,
    promocodeForm: <CratePromoCode />,
    giftcodeForm: <CreateGiftCode />,
    membershipplanForm: <CreateMemberShipPlan />,
    rightsForm: <CreateRights />,
    stateForm: <CreateState />,
    countryForm: <CreateCountry />,
    flightPlaceForm: <CreateFlightPlace />,
    walletamountreturnForm: <CreateWalletAmountReturn />,
    specialityTypeForm: <CreateSpecialityType />,
    roomTypeForm: <CreateRoomType />,
    vehicleSharingPaxForm: <CreateVehicleSharingPax />,
    itineraryFacilityForm: <CreateItineraryFacility />,
    regionForm: <CreateRegion />,
    gstForm: <CreateGst />,
    currencyForm: <CreateCurrency />,
    bankForm: <CreateBank />,
    bankaccountForm: <CreateBankAccount />,
    topuprequestForm: <CreateTopupRequest />,
    settingForm: <CreateSetting />,
    // tourserviceForm: <CreateTourService />,
  };

  return (
    <>
      {isDrawerOpen && Object.keys(drawerComponents).includes(drawerName) && (
        <AppDrawer>{drawerComponents[drawerName]}</AppDrawer>
      )}
    </>
  );
};

export default Drawers;
